import Swal from "sweetalert2";

export const successToast =  (message) => {
    Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'success',
        text: `${message}`,
        showConfirmButton: false,
        timer: 1500
    })
}

export const errorToast =  (message) => {
    Swal.fire({
        position: 'top-end',
        icon: 'error',
        text: `${message}`,
        showConfirmButton: false,
        timer: 2500
    })
}
